var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 20C10.2 19.3667 9.33333 18.875 8.4 18.525C7.46667 18.175 6.5 18 5.5 18C4.8 18 4.1125 18.0917 3.4375 18.275C2.7625 18.4583 2.11667 18.7167 1.5 19.05C1.15 19.2333 0.8125 19.225 0.4875 19.025C0.1625 18.825 0 18.5333 0 18.15V6.1C0 5.91667 0.0458333 5.74167 0.1375 5.575C0.229167 5.40833 0.366667 5.28333 0.55 5.2C1.31667 4.8 2.11667 4.5 2.95 4.3C3.78333 4.1 4.63333 4 5.5 4C6.46667 4 7.4125 4.125 8.3375 4.375C9.2625 4.625 10.15 5 11 5.5V17.6C11.85 17.0667 12.7417 16.6667 13.675 16.4C14.6083 16.1333 15.55 16 16.5 16C17.1 16 17.6875 16.05 18.2625 16.15C18.8375 16.25 19.4167 16.4 20 16.6V4.6C20.25 4.68333 20.4958 4.77083 20.7375 4.8625C20.9792 4.95417 21.2167 5.06667 21.45 5.2C21.6333 5.28333 21.7708 5.40833 21.8625 5.575C21.9542 5.74167 22 5.91667 22 6.1V18.15C22 18.5333 21.8375 18.825 21.5125 19.025C21.1875 19.225 20.85 19.2333 20.5 19.05C19.8833 18.7167 19.2375 18.4583 18.5625 18.275C17.8875 18.0917 17.2 18 16.5 18C15.5 18 14.5333 18.175 13.6 18.525C12.6667 18.875 11.8 19.3667 11 20ZM13 15V5.5L18 0.5V10.5L13 15Z",
    fill: "#00525D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.5a5aa4ef69ca1bd19071e342e858e137.svg";
export { ForwardRef as ReactComponent };